// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CursorGlowController from "./cursor_glow_controller"
application.register("cursor-glow", CursorGlowController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ScrollAnimateController from "./scroll_animate_controller"
application.register("scroll-animate", ScrollAnimateController)

import StaggerController from "./stagger_controller"
application.register("stagger", StaggerController)

import TechVizController from "./tech_viz_controller"
application.register("tech-viz", TechVizController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import HeroParticlesController from "./hero_particles_controller"
application.register("hero-particles", HeroParticlesController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)
